export default "__VITE_ASSET__fd14501c__"